import type { Change, NodeType } from '@gitbook/slate';

/**
 * Unwrap all nodes in a node.
 */
export function unwrapChildren(change: Change, node: NodeType): Change {
    if ('nodes' in node) {
        node.nodes.forEach((child: NodeType) => {
            if ('key' in child) {
                change.unwrapNodeByKey(child.key, { normalize: false });
            }
        });
    }
    return change;
}
